import { useInvestmentId } from '@hydrogen/elements.data.wealth.app.use-investment-id';
import { getCookie } from 'utils/storage';

const useClientPortfolioIds = () => {
    const clientId = String(parseInt(getCookie('client_id'), 10));
    const portfolioId = useInvestmentId();

    return { clientId, portfolioId: String(portfolioId) };
};

export default useClientPortfolioIds;
